<script>
import axios from 'axios';
import resolveUrl from '@/services/resolveUrl';
import Layout from '@/layouts/main.vue';
import PageHeader from '@/components/page-header';
import AdicionarContatoRapidoModal from '@/components/crm/grupos/AdicionarContatoRapidoModal.vue';

export default {
  name: 'GrupoDetalhe',
  components: { Layout, PageHeader, AdicionarContatoRapidoModal },
  data() {
    return {
      grupo: null,
      live: null,
      carregando: true,
      sincronizando: false,
      erro: null,
      sucesso: null,
      // Edição
      editandoAssunto: false,
      novoAssunto: '',
      salvandoAssunto: false,
      editandoDescricao: false,
      novaDescricao: '',
      salvandoDescricao: false,
      // Participantes
      novoParticipante: '',
      adicionando: false,
      acaoEmCurso: null,
      filtroParticipante: '',
      filtroPapel: '',
      // Link de convite
      linkConvite: null,
      mostrarLink: false,
      revogandoLink: false,
      copiandoLink: false,
      // Configurações (toggle)
      atualizandoConfig: false,
      // Mini-modal "adicionar contato" a partir de um participante
      modalContato: { visivel: false, nome: '', telefone: '', username: '', jid: '' },
    };
  },
  computed: {
    grupoId() { return this.$route.query.id; },
    isAdmin() { return Boolean(this.grupo && this.grupo.is_admin); },
    podeEditarInfo() {
      // Se restrict=true, só admins editam. Se false, qualquer um.
      if (!this.live) return this.isAdmin;
      return this.live.restrict ? this.isAdmin : true;
    },
    participantesFiltrados() {
      const t = (this.filtroParticipante || '').trim().toLowerCase();
      const lista = (this.live && this.live.participants) || [];
      return lista.filter((p) => {
        if (this.filtroPapel && p.papel !== this.filtroPapel) return false;
        if (!t) return true;
        const campos = [p.telefone, p.nome, p.jid].filter(Boolean).join(' ').toLowerCase();
        return campos.includes(t);
      });
    },
    contagemPorPapel() {
      const lista = (this.live && this.live.participants) || [];
      return {
        dono: lista.filter((p) => p.papel === 'dono').length,
        admin: lista.filter((p) => p.papel === 'admin').length,
        membro: lista.filter((p) => p.papel === 'membro').length,
      };
    },
    criadoEm() {
      if (!this.live || !this.live.creation) return null;
      try { return new Date(this.live.creation * 1000).toLocaleDateString('pt-BR'); } catch (_e) { return null; }
    },
  },
  async mounted() {
    await this.carregar();
  },
  methods: {
    resolveAssetUrl(relativeUrl) {
      if (!relativeUrl) return '';
      if (/^https?:\/\//i.test(relativeUrl)) return relativeUrl;
      const base = resolveUrl(process.env.VUE_APP_APIURL) || '';
      return `${base.replace(/\/$/, '')}${relativeUrl}`;
    },
    async carregar() {
      this.carregando = true;
      try {
        const { data: grupo } = await axios.get(`/grupo/${this.grupoId}`, {
          params: { include: JSON.stringify([{ model: 'CanalBaileys', as: 'canal' }]) },
        });
        this.grupo = grupo;
        this.novoAssunto = grupo.nome || '';
        this.novaDescricao = grupo.descricao || '';

        try {
          const { data: live } = await axios.get(`/grupo/live/${this.grupoId}`);
          this.live = live;
          // O backend já atualiza o grupo no DB — sincroniza o que mudou
          if (live.subject) this.grupo.nome = live.subject;
          if (live.size) this.grupo.participantes_count = live.size;
          if (live.imagemUrl) this.grupo.imagem_url = live.imagemUrl;
          if (live.desc !== undefined) this.grupo.descricao = live.desc;
        } catch (e) {
          this.erro = `Não foi possível carregar dados ao vivo: ${e.response?.data?.error || e.message}. O canal está conectado?`;
        }
      } catch (error) {
        this.erro = `Falha ao carregar: ${error.response?.data?.error || error.message}`;
      } finally {
        this.carregando = false;
      }
    },

    async sincronizar() {
      this.sincronizando = true;
      try {
        // Re-fetch live (que já dispara update no DB)
        const { data: live } = await axios.get(`/grupo/live/${this.grupoId}`);
        this.live = live;
        const { data: grupo } = await axios.get(`/grupo/${this.grupoId}`, {
          params: { include: JSON.stringify([{ model: 'CanalBaileys', as: 'canal' }]) },
        });
        this.grupo = grupo;
        this.sucesso = 'Sincronizado.';
      } catch (error) {
        this.erro = `Falha ao sincronizar: ${error.response?.data?.error || error.message}`;
      } finally {
        this.sincronizando = false;
      }
    },

    async salvarAssunto() {
      if (!this.novoAssunto.trim() || this.novoAssunto === this.grupo.nome) {
        this.editandoAssunto = false;
        return;
      }
      this.salvandoAssunto = true;
      try {
        const { data } = await axios.post(`/grupo/assunto/${this.grupoId}`, { assunto: this.novoAssunto.trim() });
        this.grupo = { ...this.grupo, ...data };
        if (this.live) this.live.subject = this.grupo.nome;
        this.editandoAssunto = false;
        this.sucesso = 'Nome do grupo atualizado.';
      } catch (error) {
        this.erro = `Falha ao renomear: ${error.response?.data?.error || error.message}`;
      } finally {
        this.salvandoAssunto = false;
      }
    },

    async salvarDescricao() {
      this.salvandoDescricao = true;
      try {
        const { data } = await axios.post(`/grupo/descricao/${this.grupoId}`, { descricao: this.novaDescricao });
        this.grupo = { ...this.grupo, ...data };
        if (this.live) this.live.desc = this.grupo.descricao;
        this.editandoDescricao = false;
        this.sucesso = 'Descrição atualizada.';
      } catch (error) {
        this.erro = `Falha ao atualizar descrição: ${error.response?.data?.error || error.message}`;
      } finally {
        this.salvandoDescricao = false;
      }
    },

    async adicionarParticipante() {
      if (!this.novoParticipante.trim()) return;
      const lista = this.novoParticipante.split(/[,\n;]/).map((s) => s.trim()).filter(Boolean);
      this.adicionando = true;
      try {
        await axios.post(`/grupo/participantes/${this.grupoId}`, { acao: 'add', participantes: lista });
        this.novoParticipante = '';
        this.sucesso = 'Participante(s) adicionado(s).';
        await this.sincronizar();
      } catch (error) {
        this.erro = `Falha ao adicionar: ${error.response?.data?.error || error.message}`;
      } finally {
        this.adicionando = false;
      }
    },

    async acaoParticipante(p, acao) {
      const labels = { remove: 'remover', promote: 'promover a admin', demote: 'rebaixar de admin' };
      const alvo = p.nome || p.telefone || p.jid;
      if (!window.confirm(`Deseja ${labels[acao]} ${alvo}?`)) return;
      this.acaoEmCurso = `${p.jid}:${acao}`;
      try {
        await axios.post(`/grupo/participantes/${this.grupoId}`, { acao, participantes: [p.jid] });
        await this.sincronizar();
        this.sucesso = `Ação "${labels[acao]}" concluída.`;
      } catch (error) {
        this.erro = `Falha: ${error.response?.data?.error || error.message}`;
      } finally {
        this.acaoEmCurso = null;
      }
    },

    async toggleAnnounce() {
      if (!this.isAdmin || !this.live) return;
      this.atualizandoConfig = true;
      const novo = !this.live.announce;
      try {
        await axios.post(`/grupo/config/${this.grupoId}`, { announce: novo });
        this.live.announce = novo;
        this.sucesso = novo ? 'Agora só admins podem enviar mensagens.' : 'Todos podem enviar mensagens.';
      } catch (error) {
        this.erro = `Falha: ${error.response?.data?.error || error.message}`;
      } finally {
        this.atualizandoConfig = false;
      }
    },

    async toggleRestrict() {
      if (!this.isAdmin || !this.live) return;
      this.atualizandoConfig = true;
      const novo = !this.live.restrict;
      try {
        await axios.post(`/grupo/config/${this.grupoId}`, { restrict: novo });
        this.live.restrict = novo;
        this.sucesso = novo ? 'Agora só admins podem editar info do grupo.' : 'Todos podem editar info.';
      } catch (error) {
        this.erro = `Falha: ${error.response?.data?.error || error.message}`;
      } finally {
        this.atualizandoConfig = false;
      }
    },

    async carregarLink() {
      if (!this.isAdmin) return;
      this.mostrarLink = true;
      if (this.linkConvite) return;
      try {
        const { data } = await axios.get(`/grupo/link/${this.grupoId}`);
        this.linkConvite = data;
      } catch (error) {
        this.erro = `Falha ao obter link: ${error.response?.data?.error || error.message}`;
      }
    },

    async revogarLink() {
      if (!window.confirm('Revogar o link atual? Ele deixa de funcionar e um novo é gerado.')) return;
      this.revogandoLink = true;
      try {
        const { data } = await axios.post(`/grupo/revogarLink/${this.grupoId}`);
        this.linkConvite = data;
        this.sucesso = 'Link revogado — um novo foi gerado.';
      } catch (error) {
        this.erro = `Falha: ${error.response?.data?.error || error.message}`;
      } finally {
        this.revogandoLink = false;
      }
    },

    copiarLink() {
      if (!this.linkConvite) return;
      try {
        navigator.clipboard.writeText(this.linkConvite.url);
        this.sucesso = 'Link copiado.';
      } catch (_e) {
        this.erro = 'Não consegui copiar — copie manualmente.';
      }
    },

    async copiarLinkDireto() {
      if (!this.isAdmin) return;
      this.copiandoLink = true;
      try {
        if (!this.linkConvite) {
          const { data } = await axios.get(`/grupo/link/${this.grupoId}`);
          this.linkConvite = data;
        }
        await navigator.clipboard.writeText(this.linkConvite.url);
        this.sucesso = 'Link de convite copiado.';
      } catch (error) {
        this.erro = `Falha ao copiar link: ${error.response?.data?.error || error.message}`;
      } finally {
        this.copiandoLink = false;
      }
    },

    async sairDoGrupo() {
      if (!window.confirm(`SAIR do grupo "${this.grupo.nome}"? O número conectado deixa de ser membro.`)) return;
      try {
        await axios.post(`/grupo/sair/${this.grupoId}`);
        this.$router.push('/app/grupos');
      } catch (error) {
        this.erro = `Falha ao sair: ${error.response?.data?.error || error.message}`;
      }
    },

    iniciarConversaCom(p) {
      if (!p.contatoId) return;
      // Nasce no módulo de Atendimento (canal oficial), reusando o fluxo/validações.
      this.$router.push({
        path: '/app/atendimento',
        query: { iniciarContatoId: p.contatoId, iniciarContatoNome: p.contatoNome || p.nome || '' },
      });
    },

    abrirAdicionarContato(p) {
      this.modalContato = {
        visivel: true,
        nome: p.nome || '',
        telefone: p.telefone || '',
        username: p.whatsappUsername || '',
        jid: p.jid || '',
      };
    },

    onContatoSalvo({ contato, jaExistia }) {
      this.sucesso = jaExistia ? 'Contato já existia — vinculado.' : 'Contato adicionado à base.';
      // Atualiza os participantes que casam com o contato recém-salvo, sem re-sincronizar.
      if (contato && this.live && Array.isArray(this.live.participants)) {
        const nome = [contato.nome, contato.sobrenome].filter(Boolean).join(' ').trim();
        const alvoTel = String(this.modalContato.telefone || '').replace(/\D/g, '');
        const alvoJid = this.modalContato.jid;
        this.live.participants.forEach((p) => {
          const casaTel = alvoTel && String(p.telefone || '').replace(/\D/g, '') === alvoTel;
          const casaJid = alvoJid && p.jid === alvoJid;
          if (casaTel || casaJid) {
            p.contatoId = contato.id;
            p.contatoNome = nome;
          }
        });
      }
    },

    voltar() { this.$router.push('/app/grupos'); },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="grupo && grupo.nome || 'Grupo'" pageTitle="Grupos" />

    <div v-if="erro" class="alert alert-danger">
      <i class="ri-error-warning-line me-1"></i>{{ erro }}
      <button class="btn-close float-end" @click="erro = null"></button>
    </div>
    <div v-if="sucesso" class="alert alert-success">
      <i class="ri-checkbox-circle-line me-1"></i>{{ sucesso }}
      <button class="btn-close float-end" @click="sucesso = null"></button>
    </div>

    <div v-if="carregando" class="text-center text-muted py-5">
      <i class="ri-loader-4-line spin"></i> Carregando...
    </div>

    <div v-else-if="grupo" class="row g-3">
      <!-- ============== Coluna esquerda: info do grupo ============== -->
      <div class="col-lg-5">
        <BCard no-body>
          <div class="card-body text-center pb-2">
            <div class="grupo-avatar mx-auto mb-3">
              <img v-if="grupo.imagem_url" :src="resolveAssetUrl(grupo.imagem_url)" class="rounded-circle img-fluid" alt="" />
              <i v-else class="ri-group-line"></i>
            </div>
            <div v-if="!editandoAssunto" class="d-flex align-items-center justify-content-center gap-2 mb-1">
              <h4 class="mb-0">{{ grupo.nome || '(sem nome)' }}</h4>
              <button v-if="podeEditarInfo" type="button" class="btn btn-sm btn-link text-muted p-0" @click="editandoAssunto = true">
                <i class="ri-pencil-line"></i>
              </button>
            </div>
            <div v-else class="d-flex gap-2 justify-content-center mb-1">
              <input v-model="novoAssunto" class="form-control form-control-sm" style="max-width: 280px;" maxlength="100" @keyup.enter="salvarAssunto" />
              <button class="btn btn-sm btn-success" :disabled="salvandoAssunto" @click="salvarAssunto">
                <i v-if="salvandoAssunto" class="ri-loader-4-line spin"></i>
                <i v-else class="ri-check-line"></i>
              </button>
              <button class="btn btn-sm btn-light" @click="editandoAssunto = false"><i class="ri-close-line"></i></button>
            </div>
            <div class="text-muted small">
              <i class="ri-group-line me-1"></i>{{ live && live.size || grupo.participantes_count }} membros
              <span v-if="grupo.canal && grupo.canal.nome"> · {{ grupo.canal.nome }}</span>
            </div>
            <div class="mt-2">
              <span v-if="grupo.is_admin" class="badge bg-success-subtle text-success">Você é admin</span>
              <span v-else class="badge bg-light text-muted">Você é membro</span>
            </div>
          </div>

          <div class="card-body border-top">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <strong class="small">Descrição</strong>
              <button v-if="podeEditarInfo && !editandoDescricao" class="btn btn-sm btn-link p-0" @click="editandoDescricao = true">
                <i class="ri-pencil-line"></i>
              </button>
            </div>
            <div v-if="!editandoDescricao" class="text-muted small" style="white-space: pre-wrap;">
              {{ grupo.descricao || 'Sem descrição.' }}
            </div>
            <div v-else>
              <textarea v-model="novaDescricao" rows="3" class="form-control"></textarea>
              <div class="mt-2 d-flex gap-2 justify-content-end">
                <button class="btn btn-sm btn-light" @click="editandoDescricao = false">Cancelar</button>
                <button class="btn btn-sm btn-success" :disabled="salvandoDescricao" @click="salvarDescricao">
                  <i v-if="salvandoDescricao" class="ri-loader-4-line spin me-1"></i>
                  Salvar
                </button>
              </div>
            </div>
          </div>

          <div class="card-body border-top small">
            <div class="d-flex justify-content-between">
              <span class="text-muted">Criado em</span>
              <span>{{ criadoEm || '—' }}</span>
            </div>
            <div v-if="live && live.owner" class="d-flex justify-content-between mt-1">
              <span class="text-muted">Dono</span>
              <span class="text-truncate ms-2" style="max-width: 70%;">{{ live.owner }}</span>
            </div>
            <div class="d-flex justify-content-between mt-1">
              <span class="text-muted">JID</span>
              <code class="small text-truncate ms-2" style="max-width: 70%;">{{ grupo.jid }}</code>
            </div>
          </div>

          <!-- Configurações admin -->
          <div v-if="isAdmin && live" class="card-body border-top">
            <strong class="small d-block mb-2">Configurações do grupo</strong>
            <div class="form-check form-switch mb-2">
              <input
                class="form-check-input"
                type="checkbox"
                id="cfg-announce"
                :checked="live.announce"
                :disabled="atualizandoConfig"
                @change="toggleAnnounce"
              />
              <label class="form-check-label small" for="cfg-announce">
                <strong>Apenas admins enviam mensagens</strong>
                <div class="text-muted">Membros comuns só leem.</div>
              </label>
            </div>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="cfg-restrict"
                :checked="live.restrict"
                :disabled="atualizandoConfig"
                @change="toggleRestrict"
              />
              <label class="form-check-label small" for="cfg-restrict">
                <strong>Apenas admins editam info</strong>
                <div class="text-muted">Nome, descrição e foto.</div>
              </label>
            </div>
          </div>

          <!-- Link de convite -->
          <div v-if="isAdmin" class="card-body border-top">
            <div class="d-flex align-items-center justify-content-between">
              <strong class="small">Link de convite</strong>
              <button type="button" class="btn btn-sm btn-link p-0" @click="carregarLink">
                <i :class="mostrarLink ? 'ri-eye-off-line' : 'ri-eye-line'"></i>
                {{ mostrarLink ? 'Ocultar' : 'Mostrar' }}
              </button>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-soft-primary w-100 mt-2"
              :disabled="copiandoLink"
              @click="copiarLinkDireto"
            >
              <i v-if="copiandoLink" class="ri-loader-4-line spin me-1"></i>
              <i v-else class="ri-clipboard-line me-1"></i>
              Copiar link de convite
            </button>
            <div v-if="mostrarLink && linkConvite" class="mt-2">
              <div class="d-flex gap-2">
                <input :value="linkConvite.url" class="form-control form-control-sm" readonly />
                <button type="button" class="btn btn-sm btn-soft-secondary" @click="copiarLink" title="Copiar">
                  <i class="ri-clipboard-line"></i>
                </button>
              </div>
              <button type="button" class="btn btn-sm btn-outline-warning mt-2" :disabled="revogandoLink" @click="revogarLink">
                <i v-if="revogandoLink" class="ri-loader-4-line spin me-1"></i>
                <i v-else class="ri-refresh-line me-1"></i>
                Revogar e gerar novo
              </button>
            </div>
          </div>

          <!-- Ações -->
          <div class="card-body border-top d-flex flex-wrap gap-2">
            <button type="button" class="btn btn-sm btn-light" @click="voltar">
              <i class="ri-arrow-left-line me-1"></i>Voltar
            </button>
            <button type="button" class="btn btn-sm btn-soft-primary" :disabled="sincronizando" @click="sincronizar">
              <i v-if="sincronizando" class="ri-loader-4-line spin me-1"></i>
              <i v-else class="ri-refresh-line me-1"></i>
              Sincronizar
            </button>
            <button type="button" class="btn btn-sm btn-outline-danger ms-auto" @click="sairDoGrupo">
              <i class="ri-logout-box-r-line me-1"></i>Sair do grupo
            </button>
          </div>
        </BCard>
      </div>

      <!-- ============== Coluna direita: participantes ============== -->
      <div class="col-lg-7">
        <BCard no-body>
          <div class="card-header">
            <div class="d-flex flex-wrap align-items-center gap-2">
              <h6 class="m-0 flex-grow-1">
                <i class="ri-team-line me-1"></i>Participantes ({{ live && live.totalParticipantes || 0 }})
              </h6>
              <input v-model="filtroParticipante" type="text" class="form-control form-control-sm" style="max-width: 220px;" placeholder="Buscar..." />
              <select v-model="filtroPapel" class="form-select form-select-sm" style="max-width: 130px;">
                <option value="">Todos</option>
                <option value="dono">Donos ({{ contagemPorPapel.dono }})</option>
                <option value="admin">Admins ({{ contagemPorPapel.admin }})</option>
                <option value="membro">Membros ({{ contagemPorPapel.membro }})</option>
              </select>
            </div>
          </div>

          <div v-if="isAdmin" class="card-body border-bottom">
            <div class="d-flex gap-2">
              <input v-model="novoParticipante" class="form-control form-control-sm" placeholder="Telefone com DDI (5511...) — separe múltiplos por vírgula" @keyup.enter="adicionarParticipante" />
              <button type="button" class="btn btn-sm btn-success" :disabled="adicionando || !novoParticipante.trim()" @click="adicionarParticipante">
                <i v-if="adicionando" class="ri-loader-4-line spin me-1"></i>
                <i v-else class="ri-user-add-line me-1"></i>
                Adicionar
              </button>
            </div>
          </div>

          <div v-if="!live" class="text-center text-muted py-5">
            Dados ao vivo indisponíveis. <a href="#" @click.prevent="sincronizar">Sincronizar</a>
          </div>
          <div v-else-if="!participantesFiltrados.length" class="text-center text-muted py-5 small">
            Nenhum participante encontrado.
          </div>
          <div v-else style="max-height: calc(100vh - 380px); overflow-y: auto;">
            <table class="table table-hover m-0 align-middle">
              <tbody>
                <tr v-for="p in participantesFiltrados" :key="p.jid">
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="part-avatar me-2">
                        <i class="ri-user-line"></i>
                      </div>
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center gap-2">
                          <strong>{{ p.nome || p.telefone || 'Desconhecido' }}</strong>
                          <span v-if="p.papel === 'dono'" class="badge bg-success-subtle text-success">Dono</span>
                          <span v-else-if="p.papel === 'admin'" class="badge bg-primary-subtle text-primary">Admin</span>
                        </div>
                        <div class="text-muted small">
                          <span v-if="p.telefone && p.nome">{{ p.telefone }} · </span>
                          <span v-if="p.contatoId" class="badge bg-info-subtle text-info me-1" title="Já cadastrado na base de contatos">na base</span>
                          <span v-if="p.ehLid" class="badge bg-warning-subtle text-warning me-1" title="Identificador anônimo do WhatsApp (LID) — telefone não disponível">LID</span>
                          <code style="font-size: 0.7rem;">{{ p.jid }}</code>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-end">
                    <!-- Identificado na base → iniciar conversa no canal oficial -->
                    <button
                      v-if="p.contatoId"
                      type="button"
                      class="btn btn-sm btn-soft-success"
                      title="Iniciar conversa no Atendimento (canal oficial)"
                      @click="iniciarConversaCom(p)"
                    >
                      <i class="ri-chat-new-line me-1"></i>Conversar
                    </button>
                    <!-- Não cadastrado, com telefone → adicionar contato -->
                    <button
                      v-else-if="p.telefone"
                      type="button"
                      class="btn btn-sm btn-soft-primary"
                      title="Adicionar à base de contatos"
                      @click="abrirAdicionarContato(p)"
                    >
                      <i class="ri-user-add-line me-1"></i>Adicionar
                    </button>
                    <!-- Sem telefone (LID/username) → ação indisponível -->
                    <button
                      v-else
                      type="button"
                      class="btn btn-sm btn-soft-secondary"
                      disabled
                      title="Telefone não disponível por privacidade (username/LID do WhatsApp)"
                    >
                      <i class="ri-lock-2-line"></i>
                    </button>
                  </td>
                  <td v-if="isAdmin" class="text-end">
                    <button
                      v-if="p.admin"
                      type="button"
                      class="btn btn-sm btn-outline-secondary me-1"
                      :disabled="acaoEmCurso === `${p.jid}:demote`"
                      @click="acaoParticipante(p, 'demote')"
                      title="Rebaixar"
                    >
                      <i class="ri-arrow-down-line"></i>
                    </button>
                    <button
                      v-else
                      type="button"
                      class="btn btn-sm btn-outline-primary me-1"
                      :disabled="acaoEmCurso === `${p.jid}:promote`"
                      @click="acaoParticipante(p, 'promote')"
                      title="Promover a admin"
                    >
                      <i class="ri-shield-check-line"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger"
                      :disabled="acaoEmCurso === `${p.jid}:remove`"
                      @click="acaoParticipante(p, 'remove')"
                      title="Remover do grupo"
                    >
                      <i class="ri-user-unfollow-line"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </BCard>
      </div>
    </div>

    <AdicionarContatoRapidoModal
      :visivel="modalContato.visivel"
      :nome-sugerido="modalContato.nome"
      :telefone-sugerido="modalContato.telefone"
      :whatsapp-username="modalContato.username"
      :jid="modalContato.jid"
      @fechar="modalContato.visivel = false"
      @salvo="onContatoSalvo"
    />
  </Layout>
</template>

<style scoped>
.spin { display: inline-block; animation: spin 1s linear infinite; }
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

.grupo-avatar {
  width: 120px; height: 120px;
  border-radius: 50%;
  background: var(--vz-primary-bg-subtle, #e9ecef);
  color: var(--vz-primary, #0d6efd);
  display: flex; align-items: center; justify-content: center;
  overflow: hidden;
  font-size: 3.2rem;
}
.grupo-avatar img { width: 100%; height: 100%; object-fit: cover; }

.part-avatar {
  width: 36px; height: 36px;
  border-radius: 50%;
  background: var(--vz-primary-bg-subtle, #e9ecef);
  color: var(--vz-primary, #0d6efd);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
</style>
